module.exports = __webpack_public_path__ + "static/img/empty.c584eb63.png";